import Transform from '@ember-data/serializer/transform';

export default class LocationTagsTransform extends Transform {
  serialize() {
    console.log('LocationTagsTransform', ...arguments);
  }
  deserialize(serialized) {
    return (serialized || []).map(s => s && s.tag);
  }
}
